export default __webpack_public_path__ + "static/media/DOLL_P5.4fd99fe0.svg";